"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const api_1 = require("../../api");
const CodePreview_1 = __importDefault(require("../common/CodePreview"));
const WordCodePreview_1 = __importDefault(require("../common/WordCodePreview"));
const PPTPreview_1 = __importDefault(require("../common/PPTPreview"));
const PDFPreview_1 = __importDefault(require("../common/PDFPreview"));
const PreviewPanel = ({ generatedCode, handleRefresh, isDragging, docType, isEditing }) => {
    const renderPreview = () => {
        switch (docType) {
            case api_1.DOC_TYPE.FORM:
                return (0, jsx_runtime_1.jsx)(CodePreview_1.default, { code: generatedCode, title: "Generated HTML/CSS", height: "calc(100vh - 144px)", showTabs: true, 
                    //   onRefresh={handleRefresh}
                    editable: true, onCodeChange: () => { }, isDragging: isDragging });
            case api_1.DOC_TYPE.WORD:
                return (0, jsx_runtime_1.jsx)(WordCodePreview_1.default, { code: generatedCode, isDragging: isDragging, isEditing: isEditing });
            case api_1.DOC_TYPE.PPT:
                return (0, jsx_runtime_1.jsx)(PPTPreview_1.default, { code: generatedCode, isDragging: isDragging, isEditing: isEditing });
            case api_1.DOC_TYPE.PDF:
                return (0, jsx_runtime_1.jsx)(PDFPreview_1.default, { code: generatedCode, isDragging: isDragging, isEditing: isEditing });
            default:
                return (0, jsx_runtime_1.jsx)("div", { children: "Unsupported document type" });
        }
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { minWidth: 0, height: "100%" }, p: 2, children: renderPreview() }));
};
exports.default = PreviewPanel;
